var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg127(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 566.71 651.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffb600;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.35,97.09c1.13.98,4.88,3.96,4.88,5.29v17.5c-5.14-.68-9.51-1.17-14.65,0v-17.5c0-1.33,3.76-4.31,4.88-5.29h4.88Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M366.88,396.7v96.48c0,8.19-12.52,20.76-20.76,20.76h-34.6v-82.64c0-2.98-5.05-8.29-8.09-9.01-3.78-.9-27.39-.92-31.02.03-3,.78-8.12,5.96-8.12,8.98v82.64h-34.6c-8.3,0-20.76-12.46-20.76-20.76v-96.48c-4.87,2.54-8.79,7.26-14.01,9.19-16.41,6.08-29.83-13.02-19.37-26.7l106.8-77.2c5.16-1.16,11.04-1.12,15.43,2.19l102.48,75.01c10.33,13.71-2.9,32.8-19.37,26.7-5.24-1.94-9.06-6.76-14.01-9.19Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M359.56,303.08c-4.46-58.77-14.99-120.77-52.93-167.71,77.42,5.93,145.2,63.5,166.3,137.78,1.16,4.09,5.29,17.58,3.1,20.63-.45.63-2.27,1.74-3.04,1.81-1.24.11-10.83-7.01-13.29-8.4-32.87-18.53-74.85-12.09-100.15,15.89Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.18,135.37c-38.15,46.01-49.17,108.62-52.92,166.89-1.41.37-1.63-.59-2.44-1.21-3.71-2.84-6.92-7.06-11.12-10.04-25.04-17.81-60.02-18.79-86.59-3.82-2.74,1.54-10.7,7.83-12.17,8.24-9.14,2.59-2.09-18.65-1.06-22.28,21.03-74.02,89-132.03,166.3-137.78Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M344.89,299.82c-31.11-30.68-82.82-30.71-113.97,0,4.24-56.91,15.14-120.74,56.68-162.78.69-.12,7.28,7.18,8.42,8.51,34.82,40.87,44.02,102.47,48.86,154.26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg127);
export default __webpack_public_path__ + "static/media/1-27.06f7800fd18d42dbce43cabd006f91bc.svg";
export { ForwardRef as ReactComponent };